//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import XyTabbarItem from './xy-tabbar-item.vue'
import router from '../../../router'
import XyTabbar from './xy-tabbar.vue'
import statisticHelper from '../../../tools/statisticalHelper'
import GlobalHelper from '../../../tools/globalHelper'
export default{
  components: {
    XyTabbarItem
  },
  methods: {
    clickItem(index) {
      // statistic
      if (index === 0) {
        statisticHelper.baseModel('bottom_channel', 'loansupermarket', '底部栏目');
      } else if (index === 1) {
        statisticHelper.baseModel('bottom_channel', 'boon', '底部栏目');
      } else if (index === 2) {
        statisticHelper.baseModel('bottom_channel', 'user_center', '底部栏目');
      }
      let children = this.$children
      for (let i = 0; i < children.length; i++) {
        children[i].selected = i === index
        if (children[i].selected) {
          window.localStorage.setItem('XYTabbarSelectIndex', i)
          switch (i) {
            case 0:
              this.$router.push({name: 'LoanProduct'})
              break;
            case 1:
              // setTimeout(() => {
              //   GlobalHelper.signClick()
              // }, 500)
              this.$router.push({name: 'welfare'})
              break;
            case 2:
              this.$router.push({name: 'UserCenter'})
              break;
            default:
              break
          }
        }
      }
    },
    // 外部调用
    clickItemWithIndex(index) {
      let children = this.$children
      for (let i = 0; i < children.length; i++) {
        children[i].selected = index === i
        if (children[i].selected) {
          window.localStorage.setItem('XYTabbarSelectIndex', i)
          switch (i) {
            case 0:
              this.$router.push({name: 'LoanProduct'})
              break
            case 1:
              // GlobalHelper.signClick()
              this.$router.push({name: 'welfare'})
              break
            case 2:
              this.$router.push({name: 'UserCenter'})
              break
            default:
              break
          }
        }
      }
    }
  },
  mounted() {
    let selectIndex = window.localStorage.getItem('XYTabbarSelectIndex')
    if (!selectIndex) {
      selectIndex = 0
      window.localStorage.setItem('XYTabbarSelectIndex', selectIndex)
    }
    let children = this.$children[selectIndex]
    children.selected = true
  }
}



// WEBPACK FOOTER //
// ./src/components/views/common/xy-tabbar.vue